import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

// Figma "Section": title 32px above the content, which is spaced 24px apart.
export const styles = (theme: Theme) => {
	return ({
		root: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(4),
		},
		heading: {
			fontWeight: "bold",
			fontSize: 18,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		content: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(3),
		},
		text: {
			fontSize: 16,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		reveal: {
			padding: 0,
		},
	} satisfies Record<string, CSSObject>);
};
